module.exports = __webpack_public_path__ + "img/58.61b2df90.jpg";